import { Injectable } from '@angular/core';
import { min, months } from 'moment';
import { TovpilDatePipe } from './TovpilDatePipe';

@Injectable({
  providedIn: 'root'
})
export class TovpilUtilsService {

  constructor() { }

  /**
   * 
   * @param text Text to add left characters
   * @param padChar character to add left example '0'
   * @param size number of padChar to add left
   * @returns '0000001'
   */
  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr((size * -1), size);
  }

  dateToTovpilDate(date: Date): string {
    let month = this.padLeft((date.getMonth() + 1).toString(), "0", 2);
    let day = this.padLeft(date.getDate().toString(), "0", 2);
    let tovpilDate: string = date.getFullYear().toString() + month + day;
    return tovpilDate;
  }
  dateToTovpilDate2(strDate: string): string {
    let dateOut: string = strDate;
    if (strDate && strDate.length > 8) {
      let dateA = strDate.split('/');
      dateOut = dateA[2] + dateA[1] + dateA[0];
    }
    return dateOut;
  }

  dateToTovpilDateFormat(date: Date) {
    if (date != null) {
      let month = this.padLeft((date.getMonth() + 1).toString(), "0", 2);
      let day = this.padLeft(date.getDate().toString(), "0", 2);
      let tovpilDate: string = day + "/" + month + "/" + date.getFullYear().toString();
      return tovpilDate;
    }
  }

  dateToTovpilDateFormatYYMMDD(date: Date) {
    let month = this.padLeft((date.getMonth() + 1).toString(), "0", 2);
    let day = this.padLeft(date.getDate().toString(), "0", 2);
    let tovpilDate: string = date.getFullYear().toString() + "-" + month + "-" + day;
    return tovpilDate;
  }

  dateToTovpilOnlyTime(date: Date): string {
    let hour = this.padLeft(date.getHours().toString(), "0", 2);
    let minutes = this.padLeft(date.getMinutes().toString(), "0", 2);
    return hour + minutes;
  }

  dateToTovpilOnlyTimeFormated(date: Date): string {
    let hour = this.padLeft(date.getHours().toString(), "0", 2);
    let minutes = this.padLeft(date.getMinutes().toString(), "0", 2);
    return hour + ":" + minutes;
  }

  /**
   * Metodo que convierte las cadenas de Fechas TOVPIL 20200504 a tipo Date
   * @param dateString 20200504
   * @returns 
   */
  convertStringToDate(dateString: string): Date {
    const re = /(\d{4})(\d{2})(\d{2})/;
    if (re.test(dateString)) {
      let year = parseInt(dateString.substring(0, 4));
      let month = parseInt(dateString.substring(4, 6)) - 1;
      let day = parseInt(dateString.substring(6, 8));
      return new Date(year, month, day);
    } else {
      return undefined
    }
  }

  stringToDate(dateString: string): Date {
    if (dateString != null) {
      const year = parseInt(dateString.substring(0, 4));
      const month = parseInt(dateString.substring(4, 6)) - 1; // Restamos 1 porque los meses van de 0 a 11 en JavaScript
      const day = parseInt(dateString.substring(6, 8));

      return new Date(year, month, day);
    }
  }

  convertStringToDateTime(timeString: string): Date {
    const tim = /(\d{2}):(\d{2})/;
    if (tim.test(timeString)) {
      let hour = parseInt(timeString.substring(0, 2));
      let minutes = parseInt(timeString.substring(3, 5));
      return new Date(0, 0, 0, hour, minutes, 0);
    } else {
      return undefined
    }
  }

  isEmailValido(email: string): boolean {
    let mailValid = false;
    const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let pattern = new RegExp(EMAIL_REGEX);
    if (pattern.test(email.trim())) {
      mailValid = true;
    }
    return mailValid;
  }

  /* */
  isNonEmptyString(str: string): boolean {
    return str && str.length > 0;
  }
  formatHours(value: string) {
    if (value.length == 4) {
      return value.substring(0, 2) + ":" + value.substring(2, 4)
    } else {
      return value;
    }
  }

  booleanify = (value: string): boolean => {
    const truthy: string[] = [
      'true',
      'True',
      '1'
    ]

    return truthy.includes(value)
  }

  booleanToString = (value: boolean): string => {
    if (value) {
      return "1";
    } else {
      return "0";
    }
  }

  validateString(str: string): boolean {
    let flag: boolean;

    if (str === null || str.trim() || str === "null") {
      flag = true;
    } else {
      flag = false;
    }

    return flag;
  }

  formatStringDate(strDate: string) {
    return this.dateToTovpilDateFormat(this.stringToDate(strDate));
  }

  convertDateFormat(inputDate: string): string {
    const [day, month, year] = inputDate.split('/');
    const originalDate = new Date(`${year}-${month}-${day}`);
    const formattedDate = originalDate.toISOString().slice(0, 10).replace(/-/g, '');
    return formattedDate;
  }

  dateToStringFormatYYMMDDMM(date: Date): string {
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add 1 because months are zero indexed
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return year + month + day + hours + minutes;
  }

  dateToStringFormatYYMMDD(date: Date): string {
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add 1 because months are zero indexed
    const day = date.getDate().toString().padStart(2, '0');

    return year + month + day;
  }


  /** For this method to work, objects in the columns arrys must have the next
   * structure
   * { field: 'field', header: 'header' }
   */
  translateCols(columns, translations) {
    const translateFGdCols = columns.map((e) => ({
      ...e,
      header: translations[e.header] != null ? translations[e.header] + (e.info ?? '') : e.header + (e.info ?? ''),
    }));
    return translateFGdCols;
  }

  deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    const cloned = Array.isArray(obj) ? [] : {};

    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        cloned[key] = this.deepClone(obj[key]);
      }
    }

    return cloned;
  }
}
